export default __webpack_public_path__ + "static/share-dea21730614b54516c96317fdb5c723b.jpg";